module.exports = __webpack_public_path__ + "static/media/4ODA4.70d131f6.jpg";